
<dx-box direction="row">
    <dxi-item *ngIf="showDateTabs" [ratio]="2">
      <dx-tabs class="tabs_daterange"
        [dataSource]="tabsDateRange"
        [(selectedIndex)]="tabsDateRangeSelectedIndex"
        [disabled]="disableSelector"
        (onSelectionChanged)="tabs_dateRange_onSelectionChanged($event)">
      </dx-tabs>
    </dxi-item>

    <dxi-item [ratio]="2" style="margin-left: 20px">
      <div *ngIf="!intervalSelected">
        <dx-box direction="row" align="left" width="100%">
          <dxi-item [baseSize]="50">
            <dx-button icon="chevronleft" [height]="47" [disabled]="disableSelector" (onClick)="prev_Click()"></dx-button>
          </dxi-item>

          <dxi-item [baseSize]="baseSizeCalendar" [disabled]="disableSelector">
            <dx-drop-down-box #calendarDropdown width="auto" [height]="47" fieldTemplate="field">
              <dx-calendar
                [(value)]="currentDate"
                [minZoomLevel]="minZoomLevel"
                [zoomLevel]="zoomLevel"
                [firstDayOfWeek]="1"
                [maxZoomLevel]="maxZoomLevel"
                [max]="maxDate"                
                (onValueChanged)="dateChanged($event, calendarDropdown)">
              </dx-calendar>
              <div *dxTemplate="let data of 'field'">
                <dx-text-box [value]="text" [readOnly]="true" [height]="47"></dx-text-box>
              </div>
            </dx-drop-down-box>
          </dxi-item>

          <dxi-item [baseSize]="50">
            <dx-button icon="chevronright" [height]="47" [disabled]="disableSelector" (onClick)="next_Click()"></dx-button>
          </dxi-item>

          <dxi-item [baseSize]="100" style="margin-left: 20px">
            <dx-button [text]="todayText" [height]="47" [visible]="hasTodayButton" [disabled]="disableSelector" (onClick)="today_Click()"></dx-button>
          </dxi-item>
        </dx-box>
      </div>

      <div *ngIf="intervalSelected">
        <dx-box direction="row" align="left" width="100%">
          <dxi-item [baseSize]="185" [disabled]="disableSelector">
            <dx-date-box [(value)]="dateFrom" [showClearButton]="true" displayFormat="dd.MM.yyyy" [height]="47" [max]="maxDate" type="date"></dx-date-box>
          </dxi-item>

          <dxi-item [baseSize]="185" style="margin-left: 5px">
            <dx-date-box [(value)]="dateTo" [showClearButton]="true" [(min)]="dateFrom" displayFormat="dd.MM.yyyy" [height]="47" [max]="maxDate" type="date"></dx-date-box>
          </dxi-item>

          <dxi-item *ngIf="showSearchButton" [baseSize]="100" style="margin-left: 20px">
            <dx-button [text]="searchText" [height]="47" [disabled]="disableSelector" (onClick)="search_Click()"></dx-button>
          </dxi-item>
        </dx-box>
      </div>
    </dxi-item>
  </dx-box>
